<template>
  <v-dialog v-model="visible" max-width="1200px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col cols="12" class="pa-0">
            <v-btn
              class="mx-1"
              color="primary"
              title="Registrar"
              small
              @click="$refs.modalFormularioCategoriasEquivalentes.abrir(acciones.REGISTRAR)">
              <v-icon>mdi-plus</v-icon>
            </v-btn>

            <v-btn
              class="mx-1"
              title="Editar"
              small
              :disabled="itemSeleccionado == null"
              @click="$refs.modalFormularioCategoriasEquivalentes.abrir(acciones.EDITAR, itemSeleccionado)">
              <v-icon>mdi-pencil</v-icon>
              Editar
            </v-btn>

            <v-btn
              class="mx-1"
              title="Eliminar"
              small
              :disabled="itemSeleccionado == null"
              @click="confirmarEliminacion">
              <v-icon>mdi-close</v-icon>
              Eliminar
            </v-btn>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoCategoriasEquivalentes
              ref="listadoRef"
              :rowData="items"
              :cargando="cargando"
              @seleccionarItem="seleccionarItem" />
          </v-col>
        </v-row>

        <ModalFormularioCategoriasEquivalentes
          ref="modalFormularioCategoriasEquivalentes"
          nombreItem="Categoría Equivalente"
          :institucionId="datos?.id"
          @actualizarListado="listar" />

        <ConfirmacionAccion ref="confirmacionRef" v-bind="confirmacion" @aceptar="eliminar" />
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import apiConsumerMixin from '../../mixins/api-consumer.mixin';
import layoutMixin from '../../mixins/layout.mixin';
import modalMixin from '../../mixins/modal.mixin';
import ListadoCategoriasEquivalentes from './ListadoCategoriasEquivalentes';
import ModalFormularioCategoriasEquivalentes from './ModalFormularioCategoriasEquivalentes.vue';
import CategoriasEquivalentesService from '../../services/categorias-equivalentes.service';
import { ACCIONES } from '../../utils/constantes';
import ConfirmacionAccion from '../../components/ConfirmacionAccion.vue';

export default {
  name: 'ModalCategoriasEquivalentes',
  mixins: [modalMixin, layoutMixin, apiConsumerMixin],
  components: {
    ListadoCategoriasEquivalentes,
    ModalFormularioCategoriasEquivalentes,
    ConfirmacionAccion,
  },
  data() {
    return {
      acciones: ACCIONES,
      confirmacion: {
        titulo: 'Acción a confirmar',
        mensaje: /*html*/ `¿Esta seguro que desea realizar esta acción?`,
        realizandoAccion: false,
      },
    };
  },
  methods: {
    abrir(data) {
      this.abrirMixin(data);
      this.listar();
    },
    async listar() {
      await this.findOneMixin(
        CategoriasEquivalentesService.findByInstitucion,
        this.datos,
        null,
        this.titulo,
        () => {
          this.items = [];
          this.itemSeleccionado = null;
          this.cargando = true;
        },
        () => {
          this.cargando = false;
        },
        (datos) => {
          this.items = datos;
        },
        () => {
          this.items = [];
          this.itemSeleccionado = null;
        },
      );
    },
    confirmarEliminacion() {
      this.confirmacion.titulo = 'Eliminar Categoría Equivalente';
      this.confirmacion.mensaje = /*html*/ `¿Está seguro de eliminar la categoria equivalente <strong>${this.itemSeleccionado?.equivalencia} ${this.itemSeleccionado?.categoriaEquivalente?.nombre}</strong> a <strong>1 ${this.itemSeleccionado?.categoria?.nombre}</strong>?`;
      this.confirmacion.realizandoAccion = false;
      this.$refs.confirmacionRef.abrir();
    },
    eliminar() {
      this.removeMixin(
        CategoriasEquivalentesService.remove,
        { id: this.itemSeleccionado?.id },
        null,
        this.titulo,
        () => {
          this.confirmacion.realizandoAccion = true;
          this.$refs.confirmacionRef.cerrar();
        },
        () => {
          this.confirmacion.realizandoAccion = false;
        },
        () => {
          this.listar();
          this.itemSeleccionado = null;
        },
      );
    },
  },
};
</script>